// extracted by mini-css-extract-plugin
export default {"form":"ordered_form__JOEin","input":"ordered_input__v9Nrx","button":"ordered_button__JSwZN","date":"ordered_date__QaNZJ","date2":"ordered_date2__0nfNF"};